























import { Vue, Component, Prop } from 'vue-property-decorator';
import Comment from '@/components/business/comments/Comment.vue';
import Swiper from 'swiper';
@Component({
  components: {
    Comment,
  },
})
export default class CommentTile extends Vue {
  @Prop() commentsData!: object;
  mounted() {
    new Swiper('#comment-swiper-pc', {
      // 一屏显示三页
      slidesPerView: 3,
      // 一次滚动三页
      slidesPerGroup: 3,
      // 无限循环
      loop: true,
      // 自动滚动
      autoplay: {
        // 自动滚动时间间隔
        delay: 3000,
        // 任意操作后停止自动播放
        disableOnInteraction: true,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      direction: 'horizontal',
    });
  }
}
